/** React */
import { useState } from "react";
import { useNavigate } from "react-router";

/** Images */
import { ReactComponent as Logo } from "../../assets/logo.svg";
import { ReactComponent as LogoSec } from "../../assets/logo-secondary.svg";

/** MUI icons */
import MenuIcon from "@mui/icons-material/Menu";

/** MUI */
import {
    AppBar,
    Box,
    Container,
    Divider,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Stack,
    useMediaQuery,
    useTheme,
} from "@mui/material";

/** Components */
import BaseButton from "../ui/BaseButton";
import classes from "./header.module.css";

const Header = (props) => {
    const { type } = props;

    /** React router */
    const navigate = useNavigate();

    /** Component variables */
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));

    /** Component states */
    const [mobileOpen, setMobileOpen] = useState(false);

    /** Component functions */
    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const goToApp = () => {
        if (typeof window !== "undefined") {
            window.open("https://go.noddok.com", "_blank");
        }
    };

    const goToHome = () => {
        navigate("/")
    };

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
            <LogoSec className={classes.logosec} />
            <Divider />
            <List disablePadding>
                <ListItem disablePadding>
                    <ListItemButton onClick={goToApp}>
                        <ListItemText primary="Try Noddok for free" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton onClick={goToApp}>
                        <ListItemText primary="Log in" />
                    </ListItemButton>
                </ListItem>
            </List>
        </Box>
    );

    return (
        <Box className={classes.floatingHeader}>
            <Container maxWidth="xl" disableGutters sx={{ justifyContent: "center", display: "flex" }}>
                <AppBar color="transparent" elevation={0} position="static" className={classes.appBar}>
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                        <Logo className={classes.logo} onClick={goToHome}/>
                        {matches && type !== "notMain" && (
                            <Stack direction="row" spacing={2}>
                                <BaseButton
                                    onClick={goToApp}
                                    variantType="secondaryContainedButton"
                                    sizebutton="l"
                                    disableElevation
                                >
                                    Try Noddok for free
                                </BaseButton>
                                <BaseButton
                                    onClick={goToApp}
                                    variantType="primaryOutlined"
                                    sizebutton="l"
                                    disableElevation
                                >
                                    Log in
                                </BaseButton>
                            </Stack>
                        )}
                        {type !== "notMain" && (
                            <IconButton
                                aria-label="open drawer"
                                edge="start"
                                onClick={handleDrawerToggle}
                                sx={{ color: '#FFF', display: { md: "none" }, px: 0 }}
                            >
                                <MenuIcon />
                            </IconButton>
                        )}
                    </Stack>
                </AppBar>
                <nav>
                    <Drawer
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                        sx={{
                            display: { xs: "block", md: "none" },
                            "& .MuiDrawer-paper": { boxSizing: "border-box", width: 240 },
                        }}
                    >
                        {drawer}
                    </Drawer>
                </nav>
            </Container>
        </Box>
    );
};

export default Header;
